/*
 * assets/vat-price.js
 * Updates the "Inc. VAT" price line when the selected variant changes.
 * Store prices are Ex. VAT; the multiplier comes from data-vat-rate
 * (1.2 = UK VAT 20%). Companion to snippets/product-price.liquid.
 * Mirrors the ProductPrice component pattern in theme.js and relies on
 * the theme's window.on/window.off event helpers, so this file must be
 * loaded after theme.js (both are ES modules, so document order holds).
 */
class VatPrice extends HTMLElement {
  connectedCallback() {
    this.amount = this.querySelector(".vat-price--amount");
    this.money_format = this.getAttribute("data-money-format");
    this.rate = parseFloat(this.getAttribute("data-vat-rate")) || 1.2;

    window.on(
      `theme:product:${this.dataset.id}:variantChanged.VatPrice`,
      ({ detail: { variant } }) => this.updatePrices(variant)
    );
  }

  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.VatPrice`);
  }

  updatePrices(variant) {
    if (!variant.id) return;
    this.amount.innerHTML = this.formatMoney(Math.round(variant.price * this.rate));
  }

  /* Same money formatting logic as ProductPrice in theme.js. */
  formatMoney(cents) {
    const decimals = this.money_format.includes("no_decimals") ? 0 : 2;
    const locale = this.money_format.includes("comma") ? "de-DE" : "en-US";
    const formatted = Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(cents / 100);
    return this.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }
}

customElements.define("vat-price-element", VatPrice);
